import React from "react";
import { Box, Typography, Tooltip, Stack } from "@mui/material";
import StatusIcon from "../../../StatusLabel/StatusIcon";
import NorthEastIcon from "@mui/icons-material/NorthEast";

const FeatureCard = ({
  title,
  subtitle,
  text,
  icon,
  tag,
  handleClick,
  alreadyPaid,
  heightIcon = "30px",
  status = "active",
  showText = true,
  hasCredential = false,
  neutralArrow = false,
  disableEntryAnimation = false,
}) => {
  const isPaid =
    typeof alreadyPaid === "function" ? alreadyPaid() : alreadyPaid;

  const isEnabled = isPaid && status === "active";

  const getChannelTheme = (name) => {
    const themes = {
      "WhatsApp API": { color: "#673ab7" },
      "WhatsApp Web": { color: "#673ab7" },
      Email: { color: "#673ab7" },
      SMS: { color: "#673ab7" },
    };
    return themes[name] || { color: "#5F1BBC", tag: "Canal" };
  };

  const theme = getChannelTheme(title);

  const isImageIcon = (icon) =>
    typeof icon === "string" &&
    (icon.startsWith("http://") || icon.startsWith("https://"));

  return (
    <Tooltip
      title={!isEnabled ? "Funcionalidade não disponível no seu plano." : null}
      arrow
      placement="top"
    >
      <Box
        onClick={isEnabled ? handleClick : undefined}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          height: "100%",
          minHeight: 226,
          padding: "12px",
          borderRadius: "18px",
          background: "#fff",
          boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
          position: "relative",
          cursor: isEnabled ? "pointer" : "not-allowed",
          transition: "all 0.3s ease",
          animation: disableEntryAnimation ? "none" : "cardFadeIn 280ms ease-out",
          "@keyframes cardFadeIn": {
            "0%": {
              opacity: 0,
              transform: "translateY(6px)",
            },
            "100%": {
              opacity: 1,
              transform: "translateY(0)",
            },
          },
          border: `1px solid ${isEnabled ? `${theme.color}22` : "rgba(148, 163, 184, 0.35)"}`,
          "&:hover": isEnabled
            ? {
                transform: "translateY(-4px) scale(1.01)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.10)",
                ".integration-arrow": {
                  borderColor: neutralArrow
                    ? "#9ca3af"
                    : hasCredential
                      ? "#16a34a"
                      : "#9ca3af",
                  color: neutralArrow
                    ? "#9ca3af"
                    : hasCredential
                      ? "#16a34a"
                      : "#9ca3af",
                },
              }
            : {},
        }}
      >
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "8px",
              border: "1px solid #e5e7eb",
              bgcolor: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
          {isImageIcon(icon) ? (
            <Box
              component="img"
              src={icon}
              alt={title}
              sx={{
                width: "76%",
                height: "76%",
                objectFit: "contain",
                display: "block",
                borderRadius: "6px",
              }}
            />
          ) : (
            <StatusIcon
              status={icon}
              color={theme.color}
              height="22px"
              width="22px"
            />
          )}
          </Box>
        </Stack>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: 15,
              fontWeight: 800,
              color: "#0f172a",
              mt: 1,
              mb: 0.4,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.02em",
                color: "#4b5563",
                mb: 1,
              }}
            >
              {subtitle}
            </Typography>
          )}

          {showText && (
            <Tooltip
              title={text || ""}
              arrow
              placement="top-start"
              enterDelay={120}
              enterNextDelay={80}
              disableHoverListener={!text}
              slotProps={{
                tooltip: {
                  sx: {
                    maxWidth: 360,
                    whiteSpace: "normal",
                    lineHeight: 1.4,
                    fontSize: 12,
                    p: 1.1,
                  },
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: 10.5,
                  color: "#4b5563",
                  lineHeight: 1.4,
                  mb: 1.2,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {text}
              </Typography>
            </Tooltip>
          )}
        </Box>

        <Box
          className="integration-arrow"
          sx={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            border: neutralArrow
              ? "1px solid #d1d5db"
              : hasCredential
                ? "1px solid #86efac"
                : "1px solid #e5e7eb",
            bgcolor: neutralArrow
              ? "#f9fafb"
              : hasCredential
                ? "#f0fdf4"
                : "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: "auto",
            alignSelf: "flex-end",
            color: neutralArrow
              ? "#9ca3af"
              : hasCredential
                ? "#16a34a"
                : "#9ca3af",
            transition: "all 0.25s ease",
          }}
        >
          <NorthEastIcon sx={{ fontSize: 20 }} />
        </Box>
      </Box>
    </Tooltip>
  );
};

export default FeatureCard;
